import { render, staticRenderFns } from "./pdfitem.vue?vue&type=template&id=18a68c22&scoped=true&"
import script from "./pdfitem.vue?vue&type=script&lang=js&"
export * from "./pdfitem.vue?vue&type=script&lang=js&"
import style0 from "./pdfitem.vue?vue&type=style&index=0&id=18a68c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a68c22",
  null
  
)

export default component.exports